module.exports = __webpack_public_path__ + "static/media/ArcGIS_Indoors_Round.a81981cb.png";